var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M489.626 506.262H204.932a6.49 6.49 0 0 1 0-12.978h284.693a6.49 6.49 0 0 1 .001 12.978z",
    fill: "#FFFFFF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.556 506.262a6.49 6.49 0 0 1-6.489-6.489V109.602a6.49 6.49 0 0 1 6.489-6.489h31.289l-81.708-81.708-81.707 81.708h24.329a6.489 6.489 0 0 1 6.489 6.489v103.28a6.49 6.49 0 0 1-6.489 6.489H242.491v85.316a6.489 6.489 0 0 1-6.489 6.489H127.734v85.315a6.489 6.489 0 0 1-6.489 6.489H12.979v96.792a6.489 6.489 0 1 1-12.978 0v-103.28a6.49 6.49 0 0 1 6.489-6.489h108.267v-85.315a6.49 6.49 0 0 1 6.489-6.489h108.267v-85.316a6.49 6.49 0 0 1 6.489-6.489h108.267v-90.302h-33.507a6.488 6.488 0 0 1-4.588-11.078L403.548 7.64a6.49 6.49 0 0 1 9.176 0l97.375 97.374a6.488 6.488 0 0 1-4.588 11.078h-40.466v383.682a6.49 6.49 0 0 1-6.489 6.488z",
    fill: "#FFFFFF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.985 506.262a6.49 6.49 0 0 1-6.489-6.489V278.684a6.49 6.49 0 0 1 12.978 0v221.089a6.49 6.49 0 0 1-6.489 6.489z",
    fill: "#FFFFFF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.2349db2ee99002d18fbecaa83351798a.svg";
export { ForwardRef as ReactComponent };